import { useHistory, useParams } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';

import { PageLayout } from '@/components/templates/PageLayout';
import { CmCard } from '@/components/uiParts';
import { redirect404Page } from '@/lib/AccessControl';
import AccountFrom from '@/pages/camel-kiosk/accounts/components/AccountFrom';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

const CamelKioskPasswordChangePage: React.FC = () => {
  // /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404Page('camel_kiosk_account_management', history, managerAccountMe);

  const { id } = useParams<{ id: string }>();
  const query = useQueryParams({
    name: StringParam,
    kioskAccountId: StringParam,
  });
  const name = query[0].name;
  const kioskAccountId = query[0].kioskAccountId;

  return (
    <PageLayout title={routes.CamelKioskPasswordChange.title}>
      <CmCard mt="25px" height={`calc(100vh - 120px)`}>
        <AccountFrom
          storeId={id}
          kioskAccountId={kioskAccountId}
          storeName={name || ''}
          type="password-change"
        />
      </CmCard>
    </PageLayout>
  );
};

export default CamelKioskPasswordChangePage;
